import { ParsedUrlQuery } from 'querystring';
import querystring from 'query-string';

import { Prices } from '@/store/prices/types';
import apiRequest from '@/utils/apiRequest';
import { RequestUserData } from '@/utils/apiRequest/types';
import { calmLogger } from '@/utils/calmLogger';
import getParamAsString from '@/utils/getParamsAsString';

import { mergeCatalogPriceIntoPrices } from '../../utils/prices/mergeCatalogPriceIntoPrices';
import { getFamilyPrices } from './getFamilyPrices';

const getCouponFromQuery = (query: ParsedUrlQuery) => {
	return query.coupon && typeof query.coupon !== 'object' ? getParamAsString(query.coupon) : null;
};

export const createPricesEndpoint = (query: ParsedUrlQuery, coupon?: string | string[] | null): string => {
	const pricesQueryParams = querystring.stringify({
		...query,
		...(typeof coupon === 'string' ? { coupon } : {}),
	});

	return `subscription/prices?${pricesQueryParams}`;
};

export async function getPrices(query: ParsedUrlQuery, userData: RequestUserData): Promise<Prices | null> {
	let sanitizedQuery = { ...query };
	if (query.guestPass && query.coupon) {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { coupon, ...rest } = query;
		sanitizedQuery = { ...rest };
	}

	const coupon = getCouponFromQuery(sanitizedQuery);
	const pricesEndpoint = createPricesEndpoint(sanitizedQuery, coupon);

	try {
		const [subPrices, familyPrice] = await Promise.all([
			apiRequest<Prices>({
				endpoint: pricesEndpoint,
				method: 'GET',
				userData,
			}),
			getFamilyPrices(userData),
		]);

		const shapedData = familyPrice
			? mergeCatalogPriceIntoPrices(familyPrice, subPrices.data, 'family')
			: subPrices.data;
		return shapedData ?? null;
	} catch (err) {
		calmLogger.error(`Error retrieving prices via GET /${pricesEndpoint}`, {}, err);
		return null;
	}
}
